import {
    EuiButton,
    EuiButtonEmpty,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFormRow,
    EuiImage,
    EuiSpacer,
    htmlIdGenerator,
} from '@elastic/eui';
import { isEmpty } from 'lodash';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import ImageSelectionContainer from '../../../components/UIComponent/ImageSelection/ImageSelectionContainer';

const LanguageBannerImage = ({
    selectedImages,
    setSelectedImages,
    buttonLabel,
    imageType,
    setValue,
    name,
    selectedImgButtonLabel = 'Change Image',
    label,
    defaultImageValue,
    aspectRatio,
    withRemove,
    isImmersive,
    aspectRatioValue,
    onAspectRatioChange,
    placeholderImage,
}) => {
    const [isShowingImageSelectionModal, setIsShowingImageSelectionModal] = useState(false);
    const isOutletMenu = useSelector((state) => state.menuReducer.isOutletMenu);

    console.log('defaultImageValue', defaultImageValue);
    console.log('!isEmpty(selectedImages)', !isEmpty(selectedImages) && selectedImages.image_url);
    console.log('imageType', imageType);



    const toggleModal = useCallback(() => {
        setIsShowingImageSelectionModal((prevState) => !prevState);
        if (!isEmpty(defaultImageValue)) {
            setSelectedImages(defaultImageValue);
        }
    }, [defaultImageValue, setSelectedImages]);

    const handleOnSave = useCallback(() => {
        setIsShowingImageSelectionModal((prevState) => !prevState);
        if (!isEmpty(selectedImages)) {
            setValue(name, selectedImages, { shouldDirty: true });
        }
    }, [name, selectedImages, setValue]);

    const handleImageSelection = useCallback(
        (image) => {
            setSelectedImages(image);
        },
        [setSelectedImages]
    );

    const onDelete = useCallback(() => {
        setSelectedImages({});
        setValue(name, {}, { shouldDirty: true });
    }, [name, setSelectedImages, setValue]);

    return (
        <>
            {isShowingImageSelectionModal ? (
                <ImageSelectionContainer
                    imageType={imageType}
                    handleOnSave={handleOnSave}
                    toggleModal={toggleModal}
                    handleImageSelection={handleImageSelection}
                    selectedImages={selectedImages}
                    aspectRatio={
                        aspectRatio?.width && aspectRatio?.height ? aspectRatio.width / aspectRatio.height : null
                    }
                    isImmersive={isImmersive}
                    aspectRatioValue={aspectRatioValue}
                    onAspectRatioChange={onAspectRatioChange}
                />
            ) : null}
            {!isEmpty(selectedImages) && selectedImages.image_url ? (
                <>
                    <EuiFormRow label={label}>
                        <EuiImage
                            size='m'
                            hasShadow
                            alt={selectedImages?.original_file_name || htmlIdGenerator()()}
                            src={selectedImages.image_url}
                        />
                    </EuiFormRow>
                    <EuiSpacer size='s' />
                </>
            ) : (
                <>
                    <EuiFormRow label={label}>
                        <EuiImage
                            size='m'
                            hasShadow
                            alt='Image unavailable'
                            src={placeholderImage}
                        />
                    </EuiFormRow>
                    <EuiSpacer size='s' />
                </>
            )}

            {!withRemove ? (
                <EuiFlexGroup justifyContent='flexStart'>
                    <EuiFlexItem grow={false}>
                        <EuiButtonEmpty disabled={isOutletMenu} onClick={toggleModal}>
                            {!selectedImages.image_url ? buttonLabel : selectedImgButtonLabel}
                        </EuiButtonEmpty>
                    </EuiFlexItem>
                </EuiFlexGroup>
            ) : (
                <EuiFlexGroup justifyContent='flexStart'>
                    <EuiFlexItem grow={false}>
                        <EuiButton fill disabled={isOutletMenu} onClick={toggleModal}>
                            {!selectedImages.image_url ? buttonLabel : selectedImgButtonLabel}
                        </EuiButton>
                    </EuiFlexItem>
                    {selectedImages.image_url ? (
                        <EuiFlexItem grow={false}>
                            <EuiButtonEmpty
                                color='danger'
                                iconType='trash'
                                disabled={isOutletMenu}
                                onClick={() => {
                                    onDelete();
                                }}
                            >
                                Delete
                            </EuiButtonEmpty>
                        </EuiFlexItem>
                    ) : null}
                </EuiFlexGroup>
            )}
        </>
    );
};

export default React.memo(LanguageBannerImage);
